import { ScopeGroupBase } from '../types/scopeGroups';

export const scopeNameComparator = (a: ScopeGroupBase, b: ScopeGroupBase) =>
  a.name > b.name ? 1 : -1;
